import React from 'react';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import { LockedLabel } from './css';

const Locked = () => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { locked }
  } = localizedStrings;
  return <LockedLabel>{locked}</LockedLabel>;
};

export default Locked;
